module.exports = __webpack_public_path__ + "static/media/home.d1183120.png";